import { inject, Injectable } from "@angular/core"
import { catchError, map, of } from "rxjs"
import { ClientService } from "@features/client/client.service"
import { AdditionalInfoSection, Client } from "@features/client/client.model"

export const enum REGISTRATION_STATE {
  NO_CLIENT = 'no_client',
  ADDITIONAL_INFO = 'additional',
  IDENTITY_VERIFICATION = 'identity',
  DISBURSEMENT_DATA = 'disbursement',
}

function mapState(client: Client | null): REGISTRATION_STATE | null {
  if (!client) {
    return REGISTRATION_STATE.NO_CLIENT
  }

  const hasAllRequiredSections = [
    AdditionalInfoSection.WORK,
    AdditionalInfoSection.FINANCE,
  ].every(prop => client.additionalInfo.hasOwnProperty(prop))

  if (!client.livingAddress || !hasAllRequiredSections) {
    return REGISTRATION_STATE.ADDITIONAL_INFO
  }

  if (!client.usernameVerified) {
    return REGISTRATION_STATE.IDENTITY_VERIFICATION
  }

  if (!client.bankAccountDisbursement) {
    return REGISTRATION_STATE.DISBURSEMENT_DATA
  }

  return null
}

@Injectable({
  providedIn: 'root'
})
export class RegistrationStateStore {
  #client = inject(ClientService)

  get() {
    return this.#client
      .refreshProfile()
      .pipe(
        map(mapState),
        catchError(() => of(null)),
      )
  }
}
